/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import * as PagesActions from 'catalog/actions/pages';
import { getAllPages, getFilter } from 'catalog/reducers/pages';
import PageList from './components/PageList';
import NoPages from './components/NoPages';
import NoResult from './components/NoResult';

type Props = {
  pages: List<CatalogPage>,
  currentFilter?: string,
  archivePage: (page: CatalogPage) => void,
};

const mapStateToProps = state => ({
  pages: getAllPages(state),
  currentFilter: getFilter(state),
});

const hasRootPages = pages => pages && pages.filter(p => p.isRoot).size > 0;
const isFiltering = filter => filter && filter.length > 0;

const Pages = ({ pages, currentFilter, archivePage }: Props) => {
  if (isFiltering(currentFilter) && pages.size === 0) {
    return <NoResult />;
  }

  if (hasRootPages(pages) || isFiltering(currentFilter)) {
    return (
      <PageList
        pages={pages}
        filter={currentFilter}
        onArchivePage={archivePage}
      />
    );
  }

  return <NoPages />;
};

export default connect(mapStateToProps, {
  archivePage: PagesActions.archivePage,
})(Pages);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Pages/index.js